module.exports = __webpack_public_path__ + "img/icon_03.686604c5.png";